export const typesStrikeEnum = {
  amount: "0.00",
  percentage: "1.00"
};
